import { http } from './http';
import { apiHelper } from 'shared';

class Users {
  get(paging, sorting, filters) {
    let queryString = '';
    queryString = apiHelper.composeQueryString({ ...paging, ...sorting, ...filters });

    return http.get(`/users/${queryString}`);
  }

  async getUsingQueryFilter(alias, projectId) {
    let queryString = '';
    queryString = apiHelper.composeQueryString({ alias, projectId });

    const response = await http.get(`/users${queryString}`);
    const items = response.data && response.data.items;

    return items;
  }

  delete(id) {
    return http.delete(`/users/${id}`);
  }

  getById(id) {
    return http.get(`/users/${id}`);
  }

  create(user) {
    return http.post('/users', { ...user, baseWebUrl: window.location.origin });
  }

  update(id, user) {
    return http.put(`/users/${id}`, user);
  }

  resetPassword(id) {
    return http.post(`/users/${id}/reset-password`, {});
  }

  getMy() {
    return http.get('/users/my');
  }

  updateMy(user) {
    return http.put('/users/my', user);
  }
}

export const users = new Users();
